export default {"src":"/bnb/_next/static/media/delta.b090a6fc.svg","height":28,"width":30};